<template>
  <!-- start: header -->
  <div id="header">
    <v-navigation-drawer v-model="drawer" app clipped class="white--text">
      <v-list dense color="white">
        <!--OPTIONS-->
        <v-list dense>
          <!--menu Options-->
          <v-list-item-group>
            <!--Administrador-->
            <v-list-item active-class="orange lighten-5" color="black" to="/admin">
                <v-list-item-avatar>
                  <v-img src="../../public/img/menu/1.png" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-sm-left">Usuario Administrador</v-list-item-title>
                    <v-list-item-subtitle> del Sistema</v-list-item-subtitle>
                </v-list-item-content>
              <!-- Comienzan Subcategorias
                        <v-list-group
                            no-action
                            sub-group
                            value="false"
              >-->
              <!--Subcategoria
                            <template v-slot:activator>
                                <v-list-item-content>
                                    <v-list-item-title class="text-sm-left">Catálogos</v-list-item-title>
                                </v-list-item-content>
              </template> especifica-->
              <!--Elementos de una subcategoria
              <v-list-item link>
                <v-list-item-title class="text-sm-left">Escolaridad</v-list-item-title>
              </v-list-item> especifica-->
              <!--finalizan subcategoria</v-list-group>-->
            </v-list-item>
            <!--Empresa Comercial-->
            <v-list-item active-class="orange lighten-5" color="black" to="/commercial">
                <v-list-item-avatar>
                  <v-img src="../../public/img/menu/2.png" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-sm-left">Empresa Comercial</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <!--Empresa Pagadora-->
            <v-list-item active-class="orange lighten-5" color="black" to="/paying">
                <v-list-item-avatar>
                  <v-img src="../../public/img/menu/3.png" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-sm-left">Empresa Pagadora</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item active-class="orange lighten-5" color="black" to="/branchs">
                <v-list-item-avatar>
                  <v-img src="../../public/img/menu/2.png" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-sm-left">Catálogo de Sucursales</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <!--Catalogo de Areas-->
            <v-list-item active-class="orange lighten-5" color="black" to="/areasList">
                <v-list-item-avatar>
                  <v-img src="../../public/img/menu/8.png" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-sm-left">Catálogo de Áreas</v-list-item-title>
                </v-list-item-content>
              <!-- Comienzan Subcategorias
                        <v-list-group
                            no-action
                            sub-group
                            value="false"
              >-->
              <!--Subcategoria
                            <template v-slot:activator>
                                <v-list-item-content>
                                    <v-list-item-title class="text-sm-left">Catálogos</v-list-item-title>
                                </v-list-item-content>
              </template> especifica-->
              <!--Elementos de una subcategoria
                            <v-list-item link>
                                <v-list-item-title class="text-sm-left">Escolaridad</v-list-item-title>
              </v-list-item> especifica-->
              <!--finalizan subcategoria</v-list-group>-->
            </v-list-item>
            <!-- Alta Puestos -->
            <v-list-item active-class="orange lighten-5" color="black" to="/jobList">
                <v-list-item-avatar>
                  <v-img src="../../public/img/menu/8.png" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-sm-left">Catálogo de Puestos</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <!-- Relación-->
            <v-list-item active-class="orange lighten-5" color="black" to="/connection">
                <v-list-item-avatar>
                  <v-img src="../../public/img/menu/10.png" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-sm-left">Relación áreas-puestos</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <!-- Alta Empleados -->
            <v-list-item active-class="orange lighten-5" color="black" to="/employeesList">
                <v-list-item-avatar>
                  <v-img src="../../public/img/menu/8.png" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-sm-left">Catálogo de Empleados</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <!-- Alta Días de vacaciones -->
            <v-list-item active-class="orange lighten-5" color="black" to="/catalogueHolidays">
                <v-list-item-avatar>
                  <v-img src="../../public/img/menu/7.png" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-sm-left">Días de Vacaciones</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <!--Calendarios-->
            <v-list-item active-class="orange lighten-5" color="black" to="/calendar">
                <v-list-item-avatar>
                  <v-img src="../../public/img/menu/4.png" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-sm-left">Calendarios</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app clipped-left color="#717171" dense>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title class="mr-5 align-center">
        <span class="title">{{step}}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <span class="title orange--text">{{stepn}}</span>
    </v-app-bar>
    <!--<v-content>
            <v-container fill-height>
                <v-layout justify-center align-center>
                    <v-flex shrink>
                    </v-flex>
                </v-layout>
            </v-container>
    </v-content>-->
  </div>
</template>
<script>
export default {
  name: "Sidebar",
  data: () => ({
    step: localStorage.step,
    stepn: localStorage.stepn,
    drawer: false
  }),
  methods: {},
  created() {}
};
</script>
<style lang="sass" scoped>

.v-navigation-drawer__border
    display: none

.v-btn--outlined .v-btn__content .v-icon, .v-btn--round .v-btn__content .v-icon
    color: white

.v-application .headline, .v-application .title
    color: white
.v-list--dense .v-list-item .v-list-item__subtitle, .v-list--dense .v-list-item .v-list-item__title, .v-list-item--dense .v-list-item__subtitle, .v-list-item--dense .v-list-item__title
    color: black
    text-decoration: none
    &::link
        text-decoration: none
.v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child
    margin: 0
.v-icon.v-icon
    color: white
.v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child
    width: 50px 
    height: 30px
    color: #fff
    padding-top: 2px
    padding-left: 4px
    background-size: 32px
    background-repeat: no-repeat
    background-image: url("../../public/img/Menu.svg")
    float: left
.enlace
    text-decoration: none
</style>